import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Photos.css';
import { Button } from 'react-bootstrap';
import cx from 'classnames';

// Component
import ListCoverPhoto from '../../ListCoverPhoto';
import ListGridCoverPhoto from '../../ListGridCoverPhoto';
import ImageSlider from '../ImageSlider';
import WishListIcon from '../../WishListIcon';

// 360
//import FsLightbox from 'fslightbox-react';
// import ScriptTag from 'react-script-tag';

// import LightGallery from 'lightgallery/react';

// import styles
// import 'lightgallery/css/lightgallery.css';
// import 'lightgallery/css/lg-zoom.css';
// import 'lightgallery/css/lg-thumbnail.css';

// If you want you can use SCSS instead of css
// import 'lightgallery/scss/lightgallery.scss';
// import 'lightgallery/scss/lg-zoom.scss';

// import plugins if you need
// import lgThumbnail from 'lightgallery/plugins/thumbnail';
// import lgZoom from 'lightgallery/plugins/zoom';
// import lgVideo from 'lightgallery/plugins/video';

/* import Lightbox from 'lightbox-react';
import 'lightbox-react/style.css'; */
// import ThreeSixty from '../../ThreeSixty';

// Redux Action
import { openImageLightBox, closeImageLightBox } from '../../../actions/ImageLightBox';
import { setStickyTop } from '../../../actions/Sticky/StrickyActions';
import { openSocialShareModal } from '../../../actions/modalActions';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

import ListDefaultPhoto from '../../ListDefaultPhoto';
import SocialShareModal from '../SocialShareModal';

// Images
import AllPhotosImage from '../../../../public/SiteImages/showAllPhotos.svg';
import threeDegreePhotos from '../../../../public/SiteImages/360ViewLising.svg';

class Photos extends React.Component {
  static propTypes = {
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    openImageLightBox: PropTypes.any.isRequired,
    closeImageLightBox: PropTypes.any.isRequired,
    imageLightBox: PropTypes.bool.isRequired,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    listPhotos: [],
    imageLightBox: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      sources: [],
      isOpen: false,
      threeSixtyToggler: false,
    };
  }

  componentDidMount() {
    const { data, setStickyTop } = this.props;
    // let listPhotos = data.listPhotos;
    const sources = [];
    let sourceObject = {};
    let coverPhoto;
    let sticky = document.querySelector('[data-sticky-top]'),
      stickyHeight = 412;

      /* const test = document.createElement("p");
      test.innerText = "TEST";
      document.body.appendChild(test); */

      /* const script = document.createElement("script");
      script.src = "https://static.kuula.io/embed.js";
      script["data-kuula"] = "https://kuula.co/share/7rcJ1?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1";
      script["data-width"] = "100%";
      script["data-height"] = "640px";
      script.async = true;
      this.div.appendChild(script); */

      // if (listPhotos != null && listPhotos.length > 0) {
    if (data.listPhotos != null && data.listPhotos.length > 0) {
      coverPhoto = data.listPhotos[0].name;

      if (data.coverPhoto != undefined && data.coverPhoto != null) {
        data.listPhotos.map((item, key) => {
          if (item.id === data.coverPhoto) {
            sourceObject = {};
            sourceObject.src = `/images/upload/x_large_${item.name}`;
            sources.push(sourceObject);
          }
        });

        data.listPhotos.map((item, key) => {
          if (item.id != data.coverPhoto) {
            sourceObject = {};
            sourceObject.src = `/images/upload/x_large_${item.name}`;
            sources.push(sourceObject);
          }
        });
      } else {
        data.listPhotos.map((item, key) => {
          sourceObject = {};
          sourceObject.src = `/images/upload/x_large_${item.name}`;
          sources.push(sourceObject);
        });
      }
      // listPhotos.map((item, key) => {
      //   let sourceObject = {};
      //   sourceObject["src"] = '/images/upload/x_large_' + item.name;
      //   //sourceObject["caption"] = 'Sydney, Australia - Photo by Jill Smith'
      //   sources.push(sourceObject);
      // });
      this.setState({ sources });
    }
    stickyHeight = (sticky.getBoundingClientRect().height + 10);
    setStickyTop(stickyHeight);
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    // let listPhotos = data.listPhotos;
    const sources = [];
    let sourceObject = {};
    let coverPhoto;

    let sticky = document.querySelector('[data-sticky-top]'),
      stickyHeight = 412;

    // if (listPhotos != null && listPhotos.length > 0) {
    if (data.listPhotos != null && data.listPhotos.length > 0) {
      coverPhoto = data.listPhotos[0].name;

      if (data.coverPhoto != undefined && data.coverPhoto != null) {
        data.listPhotos.map((item, key) => {
          if (item.id === data.coverPhoto) {
            sourceObject = {};
            sourceObject.src = `/images/upload/x_large_${item.name}`;
            sources.push(sourceObject);
          }
        });

        data.listPhotos.map((item, key) => {
          if (item.id != data.coverPhoto) {
            sourceObject = {};
            sourceObject.src = `/images/upload/x_large_${item.name}`;
            sources.push(sourceObject);
          }
        });
      } else {
        data.listPhotos.map((item, key) => {
          sourceObject = {};
          sourceObject.src = `/images/upload/x_large_${item.name}`;
          sourceObject.src = `/images/upload/x_large_${item.name}`;
          sources.push(sourceObject);
        });
      }
      // listPhotos.map((item, key) => {
      //   let sourceObject = {};
      //   sourceObject["src"] = '/images/upload/x_large_' + item.name;
      //   //sourceObject["caption"] = 'Sydney, Australia - Photo by Jill Smith'
      //   sources.push(sourceObject);
      // });
      this.setState({ sources });
    }
    stickyHeight = (sticky.getBoundingClientRect().height + 10);
    setStickyTop(stickyHeight);
  }

  render() {
    const { sources, isOpen, threeSixtyToggler } = this.state;
    const { data, openImageLightBox, closeImageLightBox, imageLightBox, openSocialShareModal, loading, currentImage } = this.props;


    const coverPhoto = data.coverPhoto;
    const listPhotos = data.listPhotos;
    const wishListStatus = data.wishListStatus;
    const isListOwner = data.isListOwner;

    /* const threeSixty = new Map([[5, {type: 'matterport', code: 'mhXoxucuzgT'}], //4 Kingdom St
                                [6, {type: 'matterport', code: 'hRoDtEQQ1Fq'}], //Monument
                                [7, {type: 'matterport', code: 'tLcRjVe6N9y'}], //CLUBCO
                                [8, {type: 'matterport', code: 'Lcz14QcXyDq'}], //One Canada Square
                                //[9, {type: 'matterport', code: '2ncCwwsR5Ab'}], //The Shard
                                [12, {type: 'matterport', code: 'zmqmGSgUGwS'}], //22 Bishopsgate
                                [14, {type: 'matterport', code: 'q1XursoQUoy'}], //WTF
                                [15, {type: 'matterport', code: 'sVkpZbh3v2q'}], //Camden Gateway
                                [23, {type: 'matterport', code: 'ikZEtaK1jTH'}], //Serviced Office Company
                                [29, {type: 'matterport', code: 'q5fNBrbzzMT'}], //TMRW Croydon
                               ]);
    let threeSixtyCode = threeSixty.get(data.id); */

    let threeSixtyCode = '';
    if( data.matterportCode ) threeSixtyCode = {type: 'matterport', code: data.matterportCode};

    return (
      <div data-sticky-top>
        <SocialShareModal listId={data.id} title={data.title} city={data.city} state={data.state} country={data.country} />
        <ImageSlider
          imageLightBox={imageLightBox}
          closeImageLightBox={closeImageLightBox}
          sources={sources}
          currentImage={currentImage}
        />

        {
          listPhotos && listPhotos.length == 0 && <ListDefaultPhoto
            className={s.bannerImage}
            coverPhoto={coverPhoto}
            listPhotos={listPhotos}
            photoType={'xx_large'}
            bgImage
          />
        }

        {
          data.isSample == true && <div className={cx(s.sampleListingContainer)}>sample</div>
        }

        {
            listPhotos && listPhotos.length == 1 && <ListCoverPhoto
              className={s.bannerImage}
              coverPhoto={coverPhoto}
              listPhotos={listPhotos}
              // sources={sources}
              photoType={'xx_large'}
              bgImage
            >
              {
                listPhotos && listPhotos.length == 1 && <div className={cx(s.viewPhotosBtn, s.viewSingleList)}>
                  <div className={s.showPhotosBtn}>
                    <Button
                      className={cx(s.btn, 'viewPhotosBtnRtl', s.btnText)}
                      onClick={() => openImageLightBox()}
                    >
                      <span><img src={AllPhotosImage} className={s.allPhotosImage} /></span>
                      <FormattedMessage {...messages.showAllPhotosLabel} />
                    </Button>
                  </div>
                  {
                    (false && threeSixtyCode) &&
                    <div className={s.threeDegreeBtn}>
                      <Button
                        className={cx(s.btn, 'viewPhotosBtnRtl', s.btnText)}
                        onClick={() => this.setState({ threeSixtyToggler: !threeSixtyToggler })}
                      >
                        <span><img src={threeDegreePhotos} className={cx(s.allPhotosImage, s.threeDegreeBtnImage)} /></span>
                        <FormattedMessage {...messages.viewLabel} />
                      </Button>
                    </div>
                  }
                </div>
              }
            </ListCoverPhoto>
          }

        {
          sources && sources.length > 1 &&
          <ListGridCoverPhoto
            // className={s.bannerImage}
            coverPhoto={coverPhoto}
            // listPhotos={listPhotos}
            listPhotos={sources}
            photoType={'xx_large'}
            bgImage
            openImageLightBox={openImageLightBox}
            threeSixtyCode={threeSixtyCode}
          />
        }
        {
          sources && sources.length > 1 && <div className={s.viewPhotosBtn}>
            <div className={s.showPhotosBtn}>
              <Button
                className={cx(s.btn, 'viewPhotosBtnRtl', s.btnText)}
                onClick={() => openImageLightBox()}
              >
                <span><img src={AllPhotosImage} className={s.allPhotosImage} /></span>
                <FormattedMessage {...messages.showAllPhotosLabel} />
              </Button>
            </div>
            {
              (false && threeSixtyCode) &&
              <div className={s.threeDegreeBtn}>
                <Button
                  className={cx(s.btn, 'viewPhotosBtnRtl', s.btnText)}
                  onClick={() => this.setState({ threeSixtyToggler: !threeSixtyToggler })}
                >
                  <span><img src={threeDegreePhotos} className={cx(s.allPhotosImage, s.threeDegreeBtnImage)} /></span>
                  <FormattedMessage {...messages.viewLabel} />
                </Button>
              </div>
            }
          </div>

        }
        {
          /* (false && threeSixtyCode) &&
          <FsLightbox
            toggler={threeSixtyToggler}
            sources={[ threeSixtyCode.type == 'matterport' ?
              <iframe width="853" height="480" src={`https://my.matterport.com/show/?m=${threeSixtyCode.code}`} frameborder="0" allowfullscreen="true" allow="xr-spatial-tracking"></iframe>
            :
              <iframe style={{ width: '800px', height: '640px', border: 'none' }} frameBorder="0" allowFullScreen="true" allow="xr-spatial-tracking; gyroscope; accelerometer" scrolling="no" src={`https://kuula.co/share/${threeSixtyCode.code}?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1`} />,
            ]}
          /> */
        }
      </div>
    );
  }
}

const mapState = state => ({
  imageLightBox: state.viewListing.imageLightBox,
  currentImage: state.viewListing.currentImage,
});

const mapDispatch = {
  openImageLightBox,
  closeImageLightBox,
  setStickyTop,
  openSocialShareModal,
};

export default withStyles(s)(connect(mapState, mapDispatch)(Photos));



// WEBPACK FOOTER //
// src/components/ViewListing/Photos/Photos.js